<template>
  <v-bottom-sheet v-bind="$attrs" :value="value" :max-width="maxWidth" @input="$emit('input', $event)">
    <section v-if="ready" :class="['rm-theme', 'rm-sheet', sheetClass]" :aria-label="label || title || null">
      <div class="rm-sheet__body">
        <div class="rm-sheet__handle"></div>
        <div v-if="title || $scopedSlots.title" class="rm-sheet__header">
          <h2><slot name="title">{{ title }}</slot></h2>
          <slot name="action"></slot>
          <button v-if="closable && !$scopedSlots.action" type="button" class="rm-icon-btn rm-icon-btn--filled" :aria-label="$t('close')" @click="$emit('input', false)">
            <v-icon size="18" color="#1c1917">mdi-close</v-icon>
          </button>
        </div>
        <slot></slot>
      </div>
      <div v-if="$scopedSlots.footer" :class="['rm-sheet__footer', footerClass]"><slot name="footer"></slot></div>
    </section>
  </v-bottom-sheet>
</template>

<script>
/**
 * Donji list na telefonu (v-model je otvoren/zatvoren): ručka, po želji zaglavlje s naslovom, sadržaj i podnožje s glavnom akcijom.
 * `title` pravi zaglavlje (naslov + dugme za zatvaranje, `:closable="false"` ga izostavlja); slot `title` mijenja sadržaj naslova
 * (npr. s podnaslovom), slot `action` zamjenjuje dugme za zatvaranje i kad ne iscrta ništa ("Poništi", broj...). Bez `title` nema zaglavlja, pa je
 * list samo ručka i sadržaj (spisak radnji). `label` je naziv za čitač ekrana kad nema `title`.
 * Slot `footer` je traka ispod sadržaja koja ostaje vidljiva. `ready=false` ne crta ništa u listu dok nema izabranog reda
 * (list čeka podatke koje otvara red). `sheet-class` i `footer-class` dodaju klasu na sam list i na podnožje (posebni stilovi ekrana).
 */
export default {
  name: "UiSheet",
  inheritAttrs: false,
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: "" },
    label: { type: String, default: "" },
    closable: { type: Boolean, default: true },
    ready: { type: Boolean, default: true },
    sheetClass: { type: [String, Array, Object], default: null },
    footerClass: { type: [String, Array, Object], default: null },
    maxWidth: { type: [String, Number], default: 600 },
  },
};
</script>
